import defaultApi from '@/utils/request';

export default {
  // ============================== S56W2002 ==================================
  // S56W2002 汽車車位申請作業
  // 取得汽車車位申請作業資料
  S99W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S08/S99/S99W4001_Load',
      params,
    });
  },

  //= ============================================================================
};
